import MailingListJson, { validateMailingListJson } from "./MailingListJson";
import { validateClientMailingRecipientJson } from "./ClientJson";
import MailingRecipientJson, { validateMailingRecipientJson } from "./MailingRecipientJson";
import MailingMessageAttachmentJson, { validateMailingMessageAttachmentJson, validateMailingMessageAttachmentJsonNew } from "./MailingMessageAttachmentJson";
import { MailingMessageStatus } from "./MailingMessageStatus";
import { Validation, ValidationResult } from "./Validation";
import CustomerJson, { validateMailingCustomerJson } from "./CustomerJson";
import { StringifyOptions } from "querystring";
import { MailingMessageRecipientContainer } from "./MailingMessageRecipientInfoJson";

/**
 * Eine einzelne Newsletter Aussendung.
 */
export default interface MailingMessageJson {
    ID: number | null,

    /**
     * Betreffzeile der Aussendung.
     */
    subject: string,

    /**
     * Inhalt der Aussendung.
     */
    body: string,

    /**
     * Gibt an, ob der E-Mail Inhalt als HTML versendet werden soll.
     */
    isHtml: boolean,

    /**
     * Status der Aussendung.
     */
    state: MailingMessageStatus,

    /**
     * Erstellzeitpunkt / Aussendungszeitpunkt der Nachricht.
     */
    broadcastDateTime: string,

    /**
     * Anhänge der Nachricht.
     */
    attachments: MailingMessageAttachmentJson[],

    /**
     * Liste an Mailinglisten, an die Nachricht versendet wird.
     */
    mailingLists: MailingListJson[],

    /**
     * Weitere manuell eingetragene Empfänger der Nachricht. Beim Speichern werden im Fall von CustomerJson und MailingRecipientJson nur die IDs abgeglichen. Änderungen an Feldern werden ignoriert.
     */
    additionalRecipients: MailingMessageRecipientContainer[];
}

export const MailingMessageBodyAllowedTags: string[] = ["p", "br", "b", "ul", "li", "u"];

export function validateMailingMessageJson(item: MailingMessageJson) {
    return new Validation(item)
        .validateInteger("ID", 0, null, false)
        .validateNonEmptyString("subject", 200)
        .validateNonEmptyString("body", null)
        .validateDate("broadcastDateTime")
        .validateAllUsingFunction("attachments", validateMailingMessageAttachmentJson)
        .validateAllUsingFunction("mailingLists", validateMailingListJson)
        .validateAllUsingFunction("additionalRecipients", validateMailingMessageRecipient)
        .finish();
}

export function validateMailingMessageRecipient(item: MailingMessageRecipientContainer) {
    if (item.type == "Customer")
        return new Validation(item)
            .validateUsingFunction("item", validateMailingCustomerJson)
            .finish();
    if (item.type == "ClientMailing")
        return new Validation(item)
            .validateUsingFunction("item", validateClientMailingRecipientJson)
            .finish();
    else
        return new Validation(item)
            .validateEmail("item")
            .finish();
}

export function validateMailingMessageJsonSend(item: MailingMessageJson) {
    return new Validation(item)
        .validateEquals("ID", null)
        .validateNonEmptyString("subject", 200)
        .validateNonEmptyString("body", null)
        .validateEquals("state", MailingMessageStatus.scheduled)
        .validateDate("broadcastDateTime")
        .validateAllUsingFunction("attachments", validateMailingMessageAttachmentJsonNew)
        .validateAllUsingFunction("mailingLists", validateMailingListJson)
        .validateAllUsingFunction("additionalRecipients", validateMailingMessageRecipient)
        .finish();
}